export const wrongSpotColor = 'rgb(239,178,45)'; // Pantone 143
export const wrongSpotColorBlind = 'rgb(249,107,7)'; // Pantone 1585
export const correctSpotColor = 'rgb(0,79,66)'; // Pantone 3305
export const correctSpotColorBlind = 'rgb(0,114,198)' // Pantone 300
export const keyboardBtnColor = 'rgb(102,109,112)';
export const notGuessedYetColor = 'rgb(68,79,81)'; // Pantone 432
export const notInSquareColor = '#080808';
export const guessHistoryColor = 'rgb(0,45,71)'; // Pantone 296
export const currentGuessColor = 'rgb(102,109,112)'; // Pantone 431
export const guessCountColor = 'rgb(0,56,107)'; // Pantone 295